import Vue from 'vue';
import {
  MdButton,
  MdIcon,
  MdList,
  MdMenu,
} from 'vue-material/dist/components';
import 'vue-material/dist/vue-material.min.css';
import VueGtag from 'vue-gtag';
import App from './App.vue';
import './app.scss';
import './theme.scss';

const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

if (isIEOrEdge) {
  window.alert('WARNING: Internet Explorer is not supported by this website. Please use a different browser.');
}

Vue.config.productionTip = false;

Vue.use(MdButton);
Vue.use(MdIcon);
Vue.use(MdList);
Vue.use(MdMenu);

Vue.use(VueGtag, {
  config: { id: 'UA-3455075-2' },
});

new Vue({
  render: (h) => h(App),
}).$mount('#app');
